// extracted by mini-css-extract-plugin
export default {"style":"AjouterProjetFavori_style__JTfG0"};